module.exports = __webpack_public_path__ + "static/media/whatsappcontorno.6b4a3084.svg";